import React, {useEffect, useState} from 'react';

import {CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot, DotGroup} from 'pure-react-carousel';

import {default as renderDots} from './Pagination';

import 'pure-react-carousel/dist/react-carousel.es.css';

import axios from "axios";

function TeamLeaderboard(props) {

    const [teams, setTeams] = useState([]);

    const [slides, setSlides] = useState([]);

    const perPage = 5;

    const {
        segment,
    } = props;

    useEffect(() => {

        axios.get(segment ? `/api/segments/${segment.id}/teams` : `/api/teams`)
            .then(result => setTeams(result.data));

    }, []);

    useEffect(() => {

        const s = [];

        for (let i = 0; i < teams.length / perPage; i++) {

            s.push(i);

        }

        setSlides(s);

    }, [teams]);

    if (teams.length > 0) return (
        <div>

            <div className="d-flex align-items-center">
                <h3 className={'mr-3'}>Teams</h3>
                <span className={'mr-auto'}>{teams.length} gesamt</span>
            </div>

            <table className={'table mb-0'}>

                <thead>
                <tr>
                    <th className={'w-12'}></th>
                    <th className={'w-auto'}>Name</th>
                    <th className={'w-25'}>Punkte</th>
                </tr>
                </thead>

            </table>

            <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={200}
                totalSlides={slides.length}
                isIntrinsicHeight={true}
            >
                <Slider>

                    {slides.map((slide, i) => {

                        return <Slide index={i} key={i}>
                            <table className={'table'}>

                                <thead style={{visibility: 'collapse'}}>
                                <tr>
                                    <th className={'w-12'}></th>
                                    <th className={'w-auto'}>Name</th>
                                    <th className={'w-25'}>Punkte</th>
                                </tr>
                                </thead>

                                <tbody>
                                {teams.slice(slide * perPage, (slide + 1) * perPage).map((team, i) => (
                                    <tr key={i}>
                                        <td colSpan={3} className={'p-0'}>
                                            <table className={'table table-borderless w-100'}>
                                                <thead>
                                                <tr>
                                                    <th className={'w-12 font-weight-normal'}>{team.rank}</th>
                                                    <th className={'w-auto font-weight-normal'}>{team.name}</th>
                                                    <th className={'w-25 font-weight-normal'}>{team.total}</th>
                                                </tr>
                                                </thead>
                                                <tbody className={'small'}>
                                                {team.athletes.sort((a, b) => (b.efforts && b.efforts.length > 0 ? b.efforts[0].team_points : 0) - (a.efforts && a.efforts.length > 0 ? a.efforts[0].team_points : 0)).map((athlete, i) => (
                                                    <tr key={i}>
                                                        <td className={'py-1'}></td>
                                                        <td className={'py-1'}>{athlete.fullname || '—'}</td>
                                                        <td className={'py-1'}>
                                                            {segment && (athlete.efforts && athlete.efforts.length > 0
                                                                ? `${athlete.efforts[0].team_points} ${athlete.sex === 'F' ? `(${athlete.efforts[0].points})` : ''}`
                                                                : '×')}
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Slide>
                    })}
                </Slider>

                <DotGroup renderDots={renderDots}></DotGroup>

            </CarouselProvider>

        </div>
    );

    return (
        <div>No efforts</div>
    )
}

export default TeamLeaderboard;
